(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["case-modern-product"] && !Shopify.designMode) return;
  try {
    
var cmSwipeState = { gallery: null, startX: 0, startY: 0 };
document.addEventListener('pointerdown', function (event) {
  var gallery = event.target.closest('.case-modern-section .cm-photo');
  if (!gallery) return;
  cmSwipeState.gallery = gallery;
  cmSwipeState.startX = event.clientX;
  cmSwipeState.startY = event.clientY;
});
document.addEventListener('pointerup', function (event) {
  var gallery = cmSwipeState.gallery;
  cmSwipeState.gallery = null;
  if (!gallery) return;
  var deltaX = event.clientX - cmSwipeState.startX;
  var deltaY = event.clientY - cmSwipeState.startY;
  if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
  var choices = Array.from(gallery.querySelectorAll('.cm-choice'));
  var currentIndex = choices.findIndex(function (choice) { return choice.checked; });
  if (currentIndex < 0) currentIndex = 0;
  var nextIndex = deltaX < 0 ? currentIndex + 1 : currentIndex - 1;
  nextIndex = Math.max(0, Math.min(choices.length - 1, nextIndex));
  if (nextIndex === currentIndex || !choices[nextIndex]) return;
  choices[nextIndex].checked = true;
  var section = gallery.closest('.case-modern-section');
  section.querySelectorAll('.cm-thumb').forEach(function (thumbnail) {
    thumbnail.classList.toggle('is-active', thumbnail.getAttribute('for') === choices[nextIndex].id);
  });
});
document.addEventListener('click', function (event) {
  var thumbnail = event.target.closest('.case-modern-section .cm-thumb');
  if (!thumbnail) return;
  event.preventDefault();
  var choiceId = thumbnail.getAttribute('for');
  if (!choiceId) return;
  var choice = document.getElementById(choiceId);
  if (!choice) return;
  choice.checked = true;
  var section = thumbnail.closest('.case-modern-section');
  section.querySelectorAll('.cm-thumb').forEach(function (item) {
    item.classList.toggle('is-active', item === thumbnail);
  });
});
document.addEventListener('click', function (event) {
  var button = event.target.closest('.case-modern-section .cm-together-add');
  if (!button) return;
  var module = button.closest('.cm-together');
  var selected = Array.from(module.querySelectorAll('.cm-together-check:checked'));
  var status = module.querySelector('.cm-together-status');
  if (!selected.length) {
    status.textContent = 'Select at least one product.';
    return;
  }
  button.disabled = true;
  status.textContent = 'Adding…';
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: selected.map(function (item) { return { id: Number(item.value), quantity: 1 }; }) })
  }).then(function (response) {
    if (!response.ok) throw new Error('Unable to add products');
    return response.json();
  }).then(function () {
    status.textContent = 'Added to cart.';
    window.location.assign(window.Shopify.routes.root + 'cart');
  }).catch(function () {
    status.textContent = 'Could not add one or more products.';
  }).finally(function () {
    button.disabled = false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
